import classNames from 'classnames'

import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

import AccordianItem, { AccordianItemProps } from '../accordianItem'

import styles from './accordian.module.scss'
import { ProductProperties } from '@src/telemetry/getProductPropertiesForTracking'

export interface AccordianProps {
  data: AccordianItemProps[]
  showFirstAccordionExpanded?: boolean
  className?: string
  productProperties?: ProductProperties
}

const Accordian = ({ data = [], showFirstAccordionExpanded, className, productProperties }: AccordianProps) => {
  const classes = classNames(styles.wrapper, className)
  return (
    <div className={classes}>
      {data.map((accordian, index) => {
        return (
          <AccordianItem
            key={accordian.key || index}
            onClick={() => {
              trackEvent(TELEMETRY_EVENT_NAMES.FAQ_CLICKED, {
                FAQ_description: accordian.header?.raw.content[0]?.content?.[0]?.value,
                productProperties,
              })
            }}
            {...accordian}
            initialState={index === 0 && showFirstAccordionExpanded}
          />
        )
      })}
    </div>
  )
}

export default Accordian
